import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Home from './components/Home';
import SuccessComp from './components/SuccessComp';
import FormState from "./contexts/form/FormState";
import PaySuccess from "./components/payment/PaySuccess";
import NotfoundComp from './components/Layouts/NotfoundComp';
import Passport from './components/passport/Index';
// import { FlwBtnComp } from './components/payment/FlwBtn';

const App = () => {
  return (
    <FormState>
      <div className="container px-2 text-center w-full mx-auto text-gray-700 font-catamaran">
        <Router>
          <Routes>
            <Route path='/' element={<Home />} />
            <Route path='/*' element={<NotfoundComp />} />
            <Route path='/passport' element={<Passport />} />
            <Route path='/success/:code' element={<SuccessComp />} />
            <Route path='/paid/:name' element={<PaySuccess />} />
          </Routes>
        </Router>
      </div>
    </FormState>
  );
}

export default App;
